import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CommonConstants } from '../common/utilities/commonConstants';
import { CookieHandlerService } from './../common/services/cookieHandler.service';
import { PopupComponent } from '../common/utilities/popup/popup.component';
import { DataLayerService } from '../common/services/dataLayer.service';

@Component({
  selector: 'app-helperlink',
  templateUrl: './helperlink.component.html',
  styleUrls: ['./helperlink.component.css']
})
export class HelperlinkComponent implements OnInit {
  public securedProductFlag: boolean;
  public prodCode: string;
  public CompanyName: string;
  public Config = { show: false, backdrop: 'static' };
  
  @ViewChild(PopupComponent, { static: false }) public PopupComponent;

  constructor(
    private _cookieHanlder: CookieHandlerService,
    private _activatedRoute: ActivatedRoute,
    private _dataLayerService: DataLayerService
  ) {
      
  }
  ngOnInit() {
    this.checkProductCode();
  }

  public OpenPopup(event) {
    this.Config.show = true;
    this.PopupComponent.ShowModalDialog(event);
  }
  public ClosePopup(event) {
    this.PopupComponent.HideModalDialog(event);
  }

  public PushDataLayerValues(thisButtonid: string) {
    let thisRoute: string = location.hash;
    const dataLayerEvent: string = CommonConstants.DataLayerEvent;
    const dataLayerPageType: string = (thisRoute.indexOf('#/') > -1) ? thisRoute.substring(2, thisRoute.length) : "";
    const dataLayerPageTitle: string = CommonConstants.DataLayerPageTitleList.FooterPopUp;
    const dataLayerCTAElementId: string = thisButtonid;
    const dataLayerProductCode: string = this._cookieHanlder.GetCookie(CommonConstants.QueryParamsKeys.Productcode);
    console.log(location.hash, 'dataLayer init - ', window['dataLayer']);
    this._dataLayerService.setWindiowDataLayer(dataLayerEvent, dataLayerPageType, dataLayerPageTitle,
        dataLayerCTAElementId, dataLayerProductCode);
}
  /*Start: Secured product check */
  private checkProductCode() {
    const prdCode = (window.name.length !== 0) ? window.name : this._cookieHanlder.GetCookie(CommonConstants.QueryParamsKeys.Productcode);
    console.log('helper link product code', prdCode);
    if (prdCode === 'DHL' || prdCode === 'DHB' ||
      prdCode === 'DLAP' || prdCode === 'DLAPB') {
      this.securedProductFlag = true;
      this.CompanyName = 'Bajaj Housing Finance'
    } if (prdCode === 'SOL') {
      this.securedProductFlag = false;
      this.CompanyName = 'Bajaj Finance'
    }
  }
  /*End: Secured product check */
}
